import { updateCompanyData, withLoginUser } from 'src/api/user'
import { CompanyDataForm } from './CompanyDataForm'

export const CompanyDataEditor = withLoginUser(({ user }) => (
  <CompanyDataForm user={user} submit={updateCompanyData} />
))
